/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tour_Home_DescInputs */

const en_wc_tour_home_desc = /** @type {(inputs: Wc_Tour_Home_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ribbon, rulers, Navigation pane and a Styles gallery that previews as you hover.`)
};

/**
* | output |
* | --- |
* | "The ribbon, rulers, Navigation pane and a Styles gallery that previews as you hover." |
*
* @param {Wc_Tour_Home_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tour_home_desc = /** @type {((inputs?: Wc_Tour_Home_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tour_Home_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tour_home_desc(inputs)
});
export { wc_tour_home_desc as "wc.tour.home.desc" }